import React, { useState } from "react";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";
import { useGetRevenueRateQuery } from "../../../Service/dashboard";
import MonthFilterSelect from "../../../Component/DigitalMarketing/MonthFilter";

const RevenueRate = () => {
  const [selectedMonth, setSelectedMonth] = useState("this Month");

  const monthOptions = [
    { value: "this Month", label: "This Month" },
    { value: "previous Month", label: "Previous Month" },
  ];

  const {
    data: revenueRate,
    refetch,
    isLoading,
  } = useGetRevenueRateQuery(selectedMonth, {
    refetchOnMountOrArgChange: true,
  });

  const data = {
    labels: [
      "Appointments Revenue",
      "Test Orders",
      "Care Packages",
      "IVF Revenue",
    ],
    datasets: [
      {
        data: [
          parseFloat(
            revenueRate?.data?.details?.appointmnetRevenue?.split("%")[0]
          ) || 0,
          parseFloat(
            revenueRate?.data?.details?.testOrderRevenue?.split("%")[0]
          ) || 0,
          parseFloat(
            revenueRate?.data?.details?.testCarepackage?.split("%")[0]
          ) || 0,
          parseFloat(
            revenueRate?.data?.details?.testIvfCustomer?.split("%")[0]
          ) || 0,
        ], // Dynamically set percentages from API response
        backgroundColor: ["#FFCDD2", "#90CAF9", "#7E57C2", "#D1C4E9"],
        hoverBackgroundColor: ["#F48FB1", "#64B5F6", "#5E35B1", "#B39DDB"],
        borderWidth: 5,
        borderColor: "#fff",
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false, // Disables the legend
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            const label = tooltipItem.label;
            const details = revenueRate?.data?.details || {};

            // Return the specific revenue value based on the label
            switch (label) {
              case "Appointments Revenue":
                return `${details.appointmnetRevenue}`;
              case "Test Orders":
                return `${details.testOrderRevenue}`;
              case "Care Packages":
                return `${details.testCarepackage}`;
              case "IVF Revenue":
                return `${details.testIvfCustomer}`;
              default:
                return label;
            }
          },
        },
      },
    },
    cutout: "85%", // Reducing the cutout to make the doughnut smaller
    responsive: true,
    rotation: Math.PI / 4,
    elements: {
      arc: {
        borderRadius: 10, // Creates rounded corners for each slice
      },
    },
  };

  return (
    <div style={{width:"100%"}}>
      <div className="d-flex justify-content-between">
        <div>
          <span className="dashboard-heading mb-4">Revenue Rate</span>
        </div>
        <div>
          <MonthFilterSelect
            value={selectedMonth}
            onChange={setSelectedMonth}
            options={monthOptions}
          />
        </div>
      </div>
      <div className="d-flex align-items-center">
        <div style={{ position: "relative", width: "250px", height: "250px" }}>
          <Doughnut data={data} options={options} />
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
            }}
          >
            <h3 style={{ color: "black", fontSize: "18px" }}>
              {revenueRate?.data?.overallTotalRevenue}
            </h3>
            <p style={{ color: "#999", fontSize: "12px" }}>
              Total Revenue Rate
            </p>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "20px",
            width: "100%",
          }}
        >
          {data.labels.map((label, index) => {
            // Retrieve the corresponding revenue detail for each label
            const revenueDetail = revenueRate?.data?.details || {};
            let revenueValue = "";

            switch (label) {
              case "Appointments Revenue":
                revenueValue = revenueDetail.appointmnetRevenue;
                break;
              case "Test Orders":
                revenueValue = revenueDetail.testOrderRevenue;
                break;
              case "Care Packages":
                revenueValue = revenueDetail.testCarepackage;
                break;
              case "IVF Revenue":
                revenueValue = revenueDetail.testIvfCustomer;
                break;
              default:
                revenueValue = "N/A";
            }

            return (
              <div
                key={label}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <span   className="text-nowrap">
                  <span
                    style={{
                      width: "14px",
                      height: "14px",
                      backgroundColor: data.datasets[0].backgroundColor[index],
                      borderRadius: "50%",
                      marginRight: "8px",
                      display: "inline-block",
                    }}
                  ></span>
                  <span
                    style={{
                      color: "#696969",
                      fontSize: "16px",
                      fontWeight: "400",
                    }}
                  
                  >
                    {label}
                  </span>
                </span>
                <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                  {revenueValue}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RevenueRate;
